import { FC, SVGProps } from 'react'

export const UserIcon: FC<SVGProps<SVGSVGElement>> = (props) => null
